<div class="d-flex flex-column flex-root">
    <div class="d-flex flex-row flex-column-fluid page">

        <!--begin::wrapper-->
        <div class="d-flex flex-column flex-row wrapper w-100" id="kt_wrapper" >
            <div id="kt_header" class="header" style="background-color: black;">
                <div class="container-fluid d-flex align-items-stretch justify-content-between">
                    <!--begin::Top Header Menu-->
                    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                        <!--begin::Header Menu-->
                        <div id="kt_header_menu" class="header-menu header-menu-mobile header-menu-layout-default">
                            <div
                                class="aside-brand categ-logo d-flex flex-column align-items-center flex-column-auto py-5 px-5 py-lg-7">
                                <h3 class="logo-df">{{commonContent?.modules.champs}}</h3>

                                <!--end::Logo-->
                            </div>
                        </div>
                        <!--end::Header Menu-->
                    </div>
                    <!--end::Top Header Menu-->
                </div>
            </div>

            <!--begin::Content-->
            <div class="content d-flex flex-column flex-column-fluid border-light-green border-red" id="kt_content">
                <div class="subheader py-2 py-lg-2 subheader-solid light-green">
                    <div
                        class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <!--begin::Info-->
                        <div class="d-flex align-items-center flex-wrap mr-2">
                            <!--begin::Page Title-->

                        </div>
                        <!--end::Info-->
                        <!--begin::Toolbar-->

                    </div>
                </div>
                <div class="d-flex flex-column-fluid">
                    <div class="container-fluid">
                        <br />
                        <br />
                        <br />
                        <h1 class="text-center">Your Are Not authorised to access this page</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer py-1 d-flex flex-lg-column">
            <!--begin::Container-->
            <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
                <!--begin::Copyright-->

                <!--end::Copyright-->
                <!--begin::Nav-->

                <div class="text-dark col-md-12 col-sm-12 col-xs-12">
                    <img class="p-2" src="assets/images/icon-coke.png" style="width:80px" /> &nbsp;&nbsp;<span
                        class="text-white">
                        Total Baseline : 6</span>&nbsp;<span class="text-white">|</span>&nbsp;<span class="text-white">
                        Total
                        Simulation : 6</span>
                </div>
                <!--end::Nav-->
            </div>
            <!--end::Container-->
        </div>

    </div>
</div>